import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class MailchimpConnectedToAnotherFundController extends Controller {
  @service fundsService;
  @service currentUser;

  get connectedToFundName() {
    return this.model.firstMailchimpFundSettingFund.name;
  }

  get listName() {
    let mcSetting = this.model.mailchimpSetting;
    let mcFund = mcSetting.fundSettings.firstObject;
    let listId = mcFund.mailchimpListId;
    return mcSetting.lists.find((x) => x.id === listId)?.name;
  }

  @action
  switchToConnectedFund() {
    this.fundsService.viewFund(this.model.firstMailchimpFundSettingFund.id, {
      urlPath: 'more/mailchimp',
    });
  }
}
